import BaseApi from '../BaseApi';
import { ReportsApiConverter } from './ReportsApiConverter';

class ReportsApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin/user`;
    this.baseUrl2 = `${baseUrl}/api/agent_admin`;
    this.converter = new ReportsApiConverter();
  }

  getStatisticProvider = ({ id, requestedBody }) =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/${id}/statistic/provider/`, requestedBody, null, data =>
      this.converter.convertStatisticProvider(data),
    );
  getPaymentHistory = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/payment/history/`,
      requestedBody,
      null,
      this.converter.convertPaymentHistory,
    );

  getPaymentHistoryTotals = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/payment/history/`,
      requestedBody,
      null,
      this.converter.convertPaymentHistoryTotals,
    );

  getStatisticPlayer = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/statistic/player/`,
      requestedBody,
      null,
      this.converter.convertStatisticPlayer,
    );

  getSlotsHistory = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/slots/history/`,
      requestedBody,
      null,
      this.converter.convertSlotsHistory,
    );

  getBetsHistory = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/bets/history/`,
      requestedBody,
      null,
      this.converter.convertBetsHistory,
    );

  getFinanceHistory = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/${id}/finance/history/`,
      requestedBody,
      null,
      this.converter.convertFinanceHistory,
    );

  // TODO: replace with api
  getRequestHistory = ({ id, requestedBody }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl2}/payment/history`,
      requestedBody,
      null,
      this.converter.convertRequestHistory,
    );

  getCashbackHistory = requestedBody =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl2}/cashback/history`,
      requestedBody,
      null,
      this.converter.convertCashbackHistory,
    );

  activateCashbackForOneUser = requestedBody =>
    this.sendQuery(this.queryTypes.PATCH, `${this.baseUrl2}/cashback/user/activate`, requestedBody, null, () => {});

  activateCashbackForStructure = requestedBody =>
    this.sendQuery(
      this.queryTypes.PATCH,
      `${this.baseUrl2}/cashback/structure/activate`,
      requestedBody,
      null,
      () => {},
    );
}

export default ReportsApi;
